import React from "react";
import type { ButtonProps, PropTypes } from "@material-ui/core";
import { Button } from "@material-ui/core";

type ToggleButtonProps = ButtonProps & { active?: boolean };

/** Adds active prop and adjust margins/borders */
export const ToggleButton = (props: ToggleButtonProps) => {
    const { active, color, ...otherProps } = props;
    const activeColor: PropTypes.Color = active ? "primary" : color;
    return (
        <Button color={activeColor} {...otherProps}>
            {props.children}
        </Button>
    );
};
